import { createEntityListPage } from "./createEntityListPage";
import { useGroups, useAddGroup, useUpdateGroup } from "../../api/lists";

export const GroupsPage = createEntityListPage({
  title: "Groups",
  entityType: "group",
  useList: useGroups,
  useAdd: useAddGroup,
  useUpdate: useUpdateGroup,
});
